import useBrowserMode from '../hooks/useBrowserMode'
import RegisterService from '../services/register'
import { localStorage, sessionStorage } from '../state/utils/storage'

const { isBrowser } = useBrowserMode()

const STORAGE_KEYS = {
	USER_DATA: 'userData',
	TOKEN_DATA: 'tokenData',
	MIGRATION_DATA: 'muid',
	USER_IDENTIFIER: 'userName',
	SAMPLES: 'samples'
}

const findStorage = key => {
	return isBrowser && (localStorage.getItem(key) || sessionStorage.getItem(key))
}

const getUserData = () => {
	return findStorage(STORAGE_KEYS.USER_DATA)
}

const getMigrationData = () => {
	if (findStorage(STORAGE_KEYS.MIGRATION_DATA)) {
		return RegisterService.getInfoMigratedUserByID(atob(findStorage(STORAGE_KEYS.MIGRATION_DATA))).then(res => {
			if (res.status === 200) {
				return res.data
			} else {
				return null
			}
		})
	} else {
		return Promise.resolve(null)
	}
}

const getTokenData = () => {
	return findStorage(STORAGE_KEYS.TOKEN_DATA)
}

const getIdTokenData = () => {
	const token = getTokenData()
	return token && token.idToken
}

const getRefreshTokenData = () => {
	const token = getTokenData()
	return token && token.refreshToken
}

const getUserName = () => {
	return findStorage(STORAGE_KEYS.USER_IDENTIFIER)
}
const getUserPoints = () => {
	const data = getUserData()
	return data && data.points
}

const haveMainDirection = () => {
	const userData = getUserData()
	return userData && userData.mainCity && userData.mainAddress
}

const haveSecondDirection = () => {
	const userData = getUserData()
	return userData && userData.secondCity && userData.secondAddress
}

const isMigrationUser = migrationData => {
	return (
		migrationData &&
		migrationData.institutionResponsable === null &&
		migrationData.roles &&
		migrationData.roles.filter(rol => rol.rolId !== 9).length > 0
	)
}

const getSamples = () => {
	return findStorage(STORAGE_KEYS.SAMPLES)
}

const SessionService = {
	getUserData,
	getMigrationData,
	getTokenData,
	getIdTokenData,
	getRefreshTokenData,
	getUserPoints,
	getUserName,
	haveMainDirection,
	haveSecondDirection,
	isMigrationUser,
	getSamples,
}

export default SessionService
